import { render, staticRenderFns } from "./CustomerSearchExport.vue?vue&type=template&id=8143a854&scoped=true&"
import script from "./CustomerSearchExport.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchExport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearchExport.vue?vue&type=style&index=0&id=8143a854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8143a854",
  null
  
)

export default component.exports